module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/protocolo-motivo/protocolo-motivo.component.css
// module id = ./src/app/protocolo-motivo/protocolo-motivo.component.css
// module chunks = main